import React from 'react';

/**
 * iOS app promotion for the public landing page.
 *
 * HARD GATE: the official Celey App Store URL is not yet confirmed.
 * This section renders NOTHING until REACT_APP_APP_STORE_URL is set to
 * the real production listing (https://apps.apple.com/app/idXXXXXXXXXX).
 * When the URL is confirmed, also generate /public/app-store-qr.png from
 * that exact URL so the desktop QR block activates.
 */
const APP_STORE_URL = process.env.REACT_APP_APP_STORE_URL;

const AppStoreBadge = () => (
  <svg viewBox="0 0 120 40" className="h-11 w-auto" role="img" aria-label="Download on the App Store">
    <rect width="120" height="40" rx="7" fill="#000" />
    <rect x="0.5" y="0.5" width="119" height="39" rx="6.5" fill="none" stroke="#a6a6a6" strokeWidth="1" />
    <path
      d="M24.77 20.3a4.95 4.95 0 0 1 2.36-4.15 5.07 5.07 0 0 0-3.99-2.16c-1.68-.18-3.31 1-4.17 1-.87 0-2.19-.98-3.61-.95a5.32 5.32 0 0 0-4.47 2.73c-1.93 3.34-.49 8.26 1.36 10.97.93 1.33 2.01 2.81 3.43 2.75 1.39-.06 1.9-.88 3.58-.88 1.66 0 2.14.88 3.59.85 1.49-.02 2.43-1.33 3.32-2.67a10.96 10.96 0 0 0 1.52-3.09 4.78 4.78 0 0 1-2.92-4.4zM22.04 12.21a4.87 4.87 0 0 0 1.11-3.49 4.96 4.96 0 0 0-3.21 1.66 4.64 4.64 0 0 0-1.14 3.36 4.1 4.1 0 0 0 3.24-1.53z"
      fill="#fff"
    />
    <text x="35" y="17" fill="#fff" fontSize="8" fontFamily="Helvetica, Arial, sans-serif">Download on the</text>
    <text x="35" y="30" fill="#fff" fontSize="13" fontWeight="600" fontFamily="Helvetica, Arial, sans-serif">App Store</text>
  </svg>
);

export const AppStorePromo = () => {
  if (!APP_STORE_URL) return null;

  return (
    <section className="pb-10" data-testid="landing-app-promo">
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 sm:flex sm:items-center sm:justify-between sm:gap-6">
        <div>
          <h2 className="text-lg font-bold text-gray-900">Plan on the go with Celey</h2>
          <p className="mt-1 text-sm text-gray-500">
            Keep your events, vendors, messages and planning with you in the Celey app.
          </p>
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-4"
            data-testid="app-store-badge-link"
          >
            <AppStoreBadge />
          </a>
        </div>
        {/* Desktop-only QR — static asset generated from the confirmed URL */}
        <div className="hidden sm:flex flex-col items-center shrink-0" data-testid="app-store-qr">
          <img
            src="/app-store-qr.png"
            alt="QR code linking to the Celey iOS app"
            className="w-24 h-24 rounded-lg border border-gray-100"
          />
          <p className="mt-2 text-[11px] text-gray-400">Scan to download on your iPhone</p>
        </div>
      </div>
    </section>
  );
};

export default AppStorePromo;
